import React, { useEffect, useState } from "react";
import { useAuth } from "../../../../../providers/AuthProvider";
import { FilterItem } from "../FilterItem/FilterItem";
import { getFilters, } from "../../../../../services/reportService";
import { LoadingOverlay } from "@mantine/core";

export function GlobalFilter(
    props:
        any) {

    const [loaderShowOnCreateAccount, setLoaderShowOnCreateAccount] =
        useState<boolean>(false);

    const authContext = localStorage.getItem("authContext") && JSON.parse(localStorage.getItem("authContext") as string);

    useEffect(() => {
        getFilters(authContext).then(data => {
            let filter = props.reportUI.globalFilter;
            let selectedFilter = props.reportUI.globalFilter.selectedFilter.list;
            let selectedId: any = {};
            selectedFilter.forEach((obj: any) => {
                selectedId[obj.id] = obj;
            });
            let allFilters = data.filtersList.filter((obj: any) => {
                if (selectedId.hasOwnProperty(obj.id)) {
                    selectedId[obj.id]["lable"] = obj.lable;
                    return false;
                }
                return true;
            }).map((f: any) => {
                return {
                    id: f.id,
                    lable: f.lable,
                    type: f.type,
                    multiSelect: f.multiSelect
                };
            })
            filter["allFilter"]["list"] = [...allFilters];
            filter["globalFilter"]["list"] = allFilters;
            props.setReportUI(props.reportUI)
        })
    },[])

    return (
        <div style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            width: "100%",
            height: "100%",
            gap: "6%",
        }}>

            {loaderShowOnCreateAccount && (
                <LoadingOverlay
                    visible={loaderShowOnCreateAccount}
                    style={{ position: "fixed" }}
                />
            )}
            <FilterItem {...props} filter={props.reportUI.globalFilter.globalFilter.list} selected={false} name="AllFilters" />
            <FilterItem {...props} filter={props.reportUI.globalFilter.selectedFilter.list} selected={true} name="SelectedFilters" />
        </div>
    );
}